import { selectSingle, isEmptyValue, clearElement, joinValues } from './LegacyModeStrategy.js';

class SingleModeStrategy {
    constructor(context) {
        this.context = context;
        this.mode = "single";
    }
    onChange() {
        if (this.context.element.value === "") {
            this.context.element.setAttribute("data-value", "");
            this.context.emitComboChange();
            return;
        }
        this.context.element.value =
            this.context.element.getAttribute("data-title") ?? this.context.element.value;
    }
    onSelect(item, index) {
        selectSingle(this.context, item, index);
    }
    getValue() {
        const value = this.context.element.getAttribute("data-value")?.trim() ?? "";
        return value || null;
    }
    setValue(value) {
        if (isEmptyValue(value)) {
            clearElement(this.context.element);
            return true;
        }
        if (Array.isArray(value)) {
            const display = joinValues(value, this.context.element, this.context.semicolon);
            this.context.element.value = display;
            this.context.element.setAttribute("data-value", "");
            this.context.element.setAttribute("data-title", display);
            return true;
        }
        const key = String(value).trim();
        this.context.element.setAttribute("data-value", key);
        if (this.context.element instanceof HTMLTextAreaElement) {
            this.context.element.value = key;
            this.context.element.setAttribute("data-title", key);
        }
        return true;
    }
    hasValue() {
        return (this.context.element.getAttribute("data-value") ?? "") !== "";
    }
    getValueTitle() {
        const title = this.context.element.getAttribute("data-title")?.trim() ?? "";
        return title || this.getValue();
    }
}

export { SingleModeStrategy };
